
export default {
    props: ['bannerData'],
    data() {
        return {
            currentIndex: 0,
            swiperOptionTop: {
                spaceBetween: 10,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev'
                },
                on: {
                    slideChange: this.slideChange
                }
            }
        }
    },
    methods: {
        slideChange() {
            this.currentIndex = this.$refs.swiperTop.swiper.activeIndex
        }
    },
    watch: {
        currentIndex(newIndex) {
            if (this.$refs.swiperTop && this.$refs.swiperTop.swiper) {
                this.$refs.swiperTop.swiper.slideTo(newIndex);
            }
        }
    }
}
